import { useQuery } from '@tanstack/react-query';

import { getWorkDay, getWorkDayFromDate } from '@/api';

export enum WorkDayQueryKeys {
  WORK_DAY = 'workday',
  WORK_DAY_FROM_DATE = 'workday-from-date'
}

export const calculateTimeUntilMidnight = () => {
  // İstanbul duvar saatini (sabit UTC+3, DST yok) cihaz saat diliminden bağımsız oku
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Istanbul',
    hourCycle: 'h23',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  }).formatToParts(new Date());
  const get = (type: string) => Number(parts.find((p) => p.type === type)?.value ?? '0');
  const secondsSinceMidnight = get('hour') * 3600 + get('minute') * 60 + get('second');

  // Hedef İstanbul 00:01; geçtiyse yarının 00:01’ini hedefle
  const targetSeconds = 60;
  const secondsUntilTarget =
    secondsSinceMidnight > targetSeconds ? 24 * 3600 + targetSeconds - secondsSinceMidnight : targetSeconds - secondsSinceMidnight;

  return secondsUntilTarget * 1000;
};

export const useWorkDay = () => {
  return useQuery({
    queryKey: [WorkDayQueryKeys.WORK_DAY],
    queryFn: () => getWorkDay(),
    refetchOnMount: true,
    refetchOnWindowFocus: true
  });
};

export const useWorkDayFromDate = (date: string | null) => {
  return useQuery({
    queryKey: [WorkDayQueryKeys.WORK_DAY_FROM_DATE, date],
    queryFn: () => getWorkDayFromDate(date!),
    enabled: !!date
  });
};
